import React from 'react'

import { Wrapper, ControlImageContainer, ControlImage } from './styles'

const Controls = props => {
    return (
        <Wrapper>
            <ControlImageContainer onClick={props.onZoomOut}>
                <ControlImage src="/assets/zoom_out.svg" alt="zoom-out" />
            </ControlImageContainer>
            <ControlImageContainer onClick={props.onRotateClick}>
                <ControlImage
                    src="/assets/controls/circular-clockwise-rotating-arrow.svg"
                    alt="rotate-clockwise"
                />
            </ControlImageContainer>
            <ControlImageContainer onClick={props.onZoomIn}>
                <ControlImage src="/assets/zoom_in.svg" alt="zoom-in" />
            </ControlImageContainer>
        </Wrapper>
    )
}

export { Controls }
